// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/loader/styles.scss
// module id = 1477
// module chunks = 0